import React, {Component} from 'react'
import {isMobileOnly} from 'react-device-detect';
import TOCChapter from './TOCChapter'

import styled from '@emotion/styled'
import sv from '../../../../styles/styles'
import {connect} from "react-redux";
import {playerActions} from "../../../../_actions/player.actions";
import {playerConstants} from "../../../../_constants/commons/playerConstants";

// STYLE ##########################################################

const TOC = styled(`div`)`
  flex: 1;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 24px 24px 0 24px;
  z-index: 3;
  ${sv.box};
  ${sv.flexColumn};
`;

const Header = styled(`div`)`
  ${sv.flexRow};
  flex: 0;
  border-bottom: 1px solid ${sv.colors.subtleLight};
  padding: 0 0 16px 0;
`;

const Close = styled(`div`)`
  flex: 0 0 70px;
  text-align: left;
  ${sv.label};
  text-transform: none;
  color: ${sv.colors.cta};
  cursor: pointer;
  &:hover {
    opacity: .7;
  }
`;

const Title = styled(`div`)`
  ${sv.label};
  color: ${sv.colors.light};
  text-align: center;
  flex: 1;
  margin-right: 70px;
`;

const Chapters = styled(`div`)`
  flex: 1;
  overflow: scroll;
  ${sv.flexRow};
  flex-wrap: wrap;
  scrollbar-width: none;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0 !important
  }
`;

// COMPONENT ##########################################################

class TableOfContents extends Component {

  state = {
    clouds: []
  };

  componentDidMount() {
  	this.props.dispatchTocViewLoad();
  }

	handleGoToChapter = (chapterNumber) => {
		this.props.goToChapter(chapterNumber);
		this.props.dispatchTocViewToChapter();
	};

	handleClose = () => {
		this.props.close();
		this.props.dispatchTocViewClose();
	};

  render() {
    const isPortrait = this.props.containerW < this.props.containerH;
	  const isMobilePortrait = isMobileOnly && isPortrait;
	  const isSmallScreen = this.props.containerW < playerConstants.CLOUD_LAYOUT_MAX_WIDTH.SMALL_SCREEN;

    let columnCount, padding;
    if ( isSmallScreen || isMobilePortrait) {
	    columnCount = 1;  // change toc-chapters to 1-column-view with (increased padding)
	    padding = 25;     // add padding to avoid more entries than actual slider (too much may results in chapter with no items)
    } else {
	    columnCount = this.props.containerW > playerConstants.CLOUD_LAYOUT_MAX_WIDTH.MEDIUM_SCREEN ? 3 : 2;
    	padding = 16;
    }

    let rowCount = this.props.chapters.length / 3;
    const headerHeight = 32;

    const chapterWidth = ((this.props.containerW - (padding*2)) / columnCount) - 8;
    let chapterHeight;
    do  {
      chapterHeight = (this.props.containerH - ( (padding*2)+headerHeight) - 6) / rowCount;
    } while (chapterHeight < 200 && --rowCount > 0);

    if (isMobileOnly) chapterHeight = 200;
    if (chapterHeight > 300) {
      chapterHeight = 250;
    }

    return (
      <TOC className="toc">
        <Header>
          <Close onClick={this.handleClose}>Close</Close>
          <Title>table of contents</Title>
        </Header>
        <Chapters>
          {
            this.props.chapters.map((chapter, index) => {
              return (
                <TOCChapter
                  key={index}
                  chapterWidth={chapterWidth}
                  chapterHeight={chapterHeight}
                  cloud={chapter}
                  chapterNumber={index+1}
                  goToChapter={this.handleGoToChapter}
                />
              )
            })
          }
        </Chapters>
      </TOC>
    )
  }

}

function mapStateToProps() {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatchTocViewLoad       : ()        => dispatch( playerActions.onTocChange(true) ),
		dispatchTocViewClose      : ()        => dispatch( playerActions.onTocChange(false) ),
		dispatchTocViewToChapter  : ()        => dispatch( playerActions.onTocChapterChange() ),
	}
}

const connectedTOC =  connect(mapStateToProps, mapDispatchToProps)(TableOfContents);
export default connectedTOC;
